'use client'

import { useKeenSlider } from 'keen-slider/react'

import { useTopNav } from '@src/components/TopNavV3/TopNavContext'
import { TopNavTile } from '@src/components/TopNavV3/TopNavTile'
import { cn } from '@src/utils/tailwind'

export const TopNavSubMenuTileSlider = () => {
  const { expandedMenu } = useTopNav()

  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    loop: false,
    mode: 'free',
    rubberband: false,
    slides: {
      perView: 'auto',
      origin: 'auto',
      spacing: 12,
    },
  })

  const tiles = (expandedMenu?.tiles ?? []).filter((tile) => tile.isVisible ?? true)
  if (tiles.length === 0) return null

  const isSingleTile = tiles.length === 1

  const renderSpacer = () => {
    if (isSingleTile) return null

    return <div className="keen-slider__slide max-w-1 min-w-1 sm:max-w-5 sm:min-w-5"></div>
  }

  return (
    <div ref={sliderRef} className="keen-slider border-t border-white/10 py-6">
      {renderSpacer()}
      {tiles.map((tile, i) => {
        const effectiveMobileColumns = isSingleTile ? 1 : 1.25 // peeking effect
        const width = `${100 / effectiveMobileColumns}%`

        return (
          <div
            key={i}
            className={cn('keen-slider__slide', {
              'px-4': isSingleTile,
            })}
            style={{ minWidth: width, maxWidth: width }}
          >
            <TopNavTile key={i} tile={tile} />
          </div>
        )
      })}
      {renderSpacer()}
    </div>
  )
}
